import { SerieItem } from "./serie-item";
import { Video } from "./video";

export class Application {

	constructor() {

		this.videos = 0
	}

	videos: number;
	paywallSlider: SerieItem[] | Video[];
	notification: Notification;
}

export class Notification {

	enabled: boolean;
	message: string;
}